const initPopover = (elems) => {
  const popout = document.querySelector('.js-geo-popover');
  if (popout)
  {
    popout.classList.remove('noAnimate')
    
    const openListener = (elem) => {
      elem.addEventListener('click', () => {
        popout.classList.add('open')
      })
    }
    const closeListener = (elem) => {
      elem.addEventListener('click', () => {
        popout.classList.remove('open')
      })
    }
    const toggleListener = (elem) => {
      elem.addEventListener('click', () => {
        if (popout.classList.contains('open'))
        {
          popout.classList.remove('open')
        }
        else
        {
          popout.classList.add('open')
        }
      })
    }

    elems.forEach(elem => {
      switch (elem.dataset.geoPopover)
      {
        case 'open':
          openListener(elem);
          break;
        case 'close':
          closeListener(elem);
          break;
        case 'toggle':
          toggleListener(elem);
          break;
      }
    });
    setTimeout(() => {
      popout.classList.add('loaded')
    }, 400);
  }
}


const popoverDataElements = [...document.querySelectorAll(`[data-geo-popover]`)];

initPopover(popoverDataElements);





